import { Link } from 'react-router-dom'
import {
    BarChart, Bar, XAxis, Tooltip, ResponsiveContainer
} from 'recharts'
import {
    Container, Title, DataContainer, CountContainer, ChartContainer, Count
} from './style'
import { Section } from '../section'
import { useDadosEcossistema } from './state'
import { Button } from '../button'

export default function DadosEcossisitema() {
    const { data } = useDadosEcossistema()

    return (
        <Section>
            <Container>
                <Title>
                    Estatísticas do Ecossistema
                </Title>
                <DataContainer>
                    <CountContainer>
                        <Count>
                            <span>{data[0]?.total}</span>
                            <span>Startups</span>
                        </Count>
                        <Count>
                            <span>{data[1]?.total}</span>
                            <span>Aceleradoras</span>
                        </Count>
                        <Count>
                            <span>{data[2]?.total}</span>
                            <span>Investidores</span>
                        </Count>
                        <Count>
                            <span>{data[3]?.total}</span>
                            <span>Projetos de inovação</span>
                        </Count>
                    </CountContainer>
                    <ChartContainer>
                        <ResponsiveContainer width="100%" height="100%">
                            <BarChart
                                width={500}
                                height={400}
                                data={data}
                                margin={{
                                    top: 20,
                                    right: 0,
                                    left: 0,
                                    bottom: 5
                                }}
                            >
                                <XAxis dataKey="nome" />
                                <Tooltip />
                                <Bar
                                    dataKey="total"
                                    stackId="a"
                                    fill="#82ca9d"
                                />
                            </BarChart>
                        </ResponsiveContainer>
                    </ChartContainer>
                </DataContainer>
                <Link to="/estatistica-ecossistema">
                    <Button>
                        Ver dados
                    </Button>
                </Link>
            </Container>
        </Section>
    )
}
